import type { RefOrGetter } from "ls/common/types";
import { useQuery } from "@tanstack/vue-query";
import { computed, toValue } from "vue";
import { queries } from "./queries";

export function useFile(shortcut: RefOrGetter<string | undefined>) {
  const queryOptions = computed(() => queries.info(toValue(shortcut)));
  const query = useQuery(queryOptions);

  return query.data;
}
